export const transformPrebidVersion = (version) => version.replace('v', '').replace(/\./g, '-');
